import React, { useState, useEffect } from 'react';

const YouTubePlaylist = ({ playlistId, maxResults = 4 }) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // You'll need to add your YouTube API key here
  const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || 'YOUR_API_KEY_HERE';

  useEffect(() => {
    const fetchPlaylistVideos = async () => {
      try {
        setLoading(true);
        
        // YouTube Data API v3 endpoint for playlist items
        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${playlistId}&key=${API_KEY}`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (data.error) {
          throw new Error(data.error.message);
        }

        setVideos(data.items || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching YouTube playlist:', err);
        setError(err.message);
        // Fallback to empty array if API fails
        setVideos([]);
      } finally {
        setLoading(false);
      }
    };

    if (playlistId && API_KEY && API_KEY !== 'YOUR_API_KEY_HERE') {
      fetchPlaylistVideos();
    } else {
      setLoading(false);
      setError('YouTube API key not configured');
    }
  }, [playlistId, maxResults, API_KEY]);

  if (loading) {
    return (
      <div className="recommended-videos-grid">
        {[...Array(maxResults)].map((_, index) => (
          <div key={index} className="recommended-video-card loading">
            <div className="video-loading-placeholder">
              <div className="loading-spinner"></div>
              <p>Loading video {index + 1}...</p>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="youtube-error">
        <h3>Unable to load videos</h3>
        <p>Error: {error}</p>
        <p>Please check your YouTube API configuration or try again later.</p>
        <div className="fallback-playlist">
          <iframe
            width="100%"
            height="400"
            src={`https://www.youtube.com/embed/videoseries?list=${playlistId}`}
            title="YouTube Playlist"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    );
  }

  if (videos.length === 0) {
    return (
      <div className="no-videos">
        <h3>No videos found</h3>
        <p>The playlist appears to be empty or private.</p>
      </div>
    );
  }

  return (
    <div className="recommended-videos-grid">
      {videos.map((video, index) => {
        const videoId = video.snippet.resourceId.videoId;
        const title = video.snippet.title;
        // const thumbnail = video.snippet.thumbnails.medium?.url || video.snippet.thumbnails.default?.url;
        const channelTitle = video.snippet.channelTitle;
        const publishedAt = new Date(video.snippet.publishedAt).toLocaleDateString();

        return (
          <div key={videoId} className="recommended-video-card">
            <div className="video-embed">
              <iframe
                width="100%"
                height="200"
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="video-info">
              <h4 className="video-title">{title}</h4>
              <p className="video-meta">
                <span className="channel-name">{channelTitle}</span>
                <span className="publish-date">{publishedAt}</span>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default YouTubePlaylist;